import { render } from "./showGroups.vue?vue&type=template&id=15316f1a&scoped=true"
import script from "./showGroups.vue?vue&type=script&lang=js"
export * from "./showGroups.vue?vue&type=script&lang=js"

import "./showGroups.vue?vue&type=style&index=0&id=15316f1a&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15316f1a"]])

export default __exports__